import { get, post, postAttachmentData, put, remove } from './mainApi';

const yearPlannerServiceBaseURL = process.env.REACT_APP_WORKLOG_MANAGEMENT_ENDPOINT;
const yearPlanBaseURL = process.env.REACT_APP_YEAR_PLAN;

export const getLeaveForSelectedMonth = async (month: number, year: number) => {
  const response = get(`${yearPlanBaseURL}GetTypeByMonthYear?month=${month}&year=${year}`);
  return response;
};

export const updateCompanyLeave = async ( data ) => {
  const response = post(`${yearPlanBaseURL}calendaritems/bulkoperations`, {CompanyCalendarItems : data});
  return response;
};

export const addCompanyLeave = async ( data ) => {
  const response = post(`${yearPlanBaseURL}calendaritems/bulk`, {CompanyCalendarItems : data});
  return response;
};

export const deleteCompanyLeave = async (id: string) => {
  var response = remove(`${yearPlanBaseURL}calendaritem/${id}`);
  return response;
};

export const addCompanyLeaveBulk = async (file: FormData) => {
  const response = postAttachmentData(`${yearPlanBaseURL}calendaritems/excelupload`, file);
  return response;
};

export const createShadowResource = async (data: any) => {
  var response = post(
    `${yearPlannerServiceBaseURL}/shadow-resource/create`,
    data
  );
  return response;
};

export const updateShadowResource = async (data: any) => {
  var response = put(
    `${yearPlannerServiceBaseURL}/shadow-resource/update`,
    data
  );
  return response;
};

export const getAllShadowResources = async () => {
  var response = get(`${yearPlannerServiceBaseURL}/resource-management`);
  return response;
};

export const searchShadows = async (shadowName: string) => {
  var response = post(`${yearPlannerServiceBaseURL}/shadow-resource/search`, {
    NameInJira: shadowName
  });
  return response;
};

export const endShadows = async (id: string) => {
  var response = remove(`${yearPlannerServiceBaseURL}/shadow-resource/end`, {
    Id: id
  });
  return response;
};

export const getLeaveTypes = async () => {
  const response = get(`${yearPlanBaseURL}types`);
  return response;
};

export const addLeaveType = async (value) => {
  const response = post(`${yearPlanBaseURL}type`, {description : value});
  return response;
};

export const deleteLeaveType = async (value) => {
  const response = remove(`${yearPlanBaseURL}types/${value}`);
  return response;
};